import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Card } from '@/components/ui/card';
import { Bot } from 'lucide-react';

export function TypingIndicator() {
  return (
    <div className="flex gap-3 mb-4">
      <Avatar className="w-8 h-8 mt-1">
        <AvatarFallback className="bg-gray-100 text-gray-600 text-xs">
          <Bot className="w-4 h-4" />
        </AvatarFallback>
      </Avatar>
      
      <Card data-testid="typing-indicator" className="px-4 py-3 bg-white border-gray-200 shadow-sm">
        <div className="flex space-x-1">
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
        </div>
      </Card>
    </div>
  );
}